{
  "images": [
    {
      "src": "inside_1.jpeg",
      "alt": "手洗い場"
    },
    {
      "src": "inside_2.jpeg",
      "alt": "トイレ"
    },
    {
      "src": "inside_3.jpeg",
      "alt": "多目的トイレ"
    },
    {
      "src": "inside_4.jpeg",
      "alt": "授乳室"
    },
    {
      "src": "inside_5.jpeg",
      "alt": "大型鏡"
    },
    {
      "src": "inside_6.jpeg",
      "alt": "休憩コーナー"
    }
  ],
  "basic_rules": [
    {
      "title": "一．広場利用の考え方",
      "list": [
        "広場はすべての人に開かれた空間であり、自由な利用を基本とする。",
        "広場は憩いの空間であり、にぎわいの空間でもある。",
        "広場は使い方やアイデア次第で様々な姿を見せる空間である。",
        "広場と港の風景を大切にし、みなとまち新潟への親しみを深める。"
      ]
    },
    {
      "title": "二．きれいな広場を守るために",
      "list": [
        "ごみは捨てずに、持ち帰る。",
        "水辺に物を投げ入れない。",
        "トイレや手洗い場など、広場の設備はきれいに使用する。",
        "広場内を汚した場合は、責任を持ってきれいにする。"
      ]
    },
    {
      "title": "三．秩序ある広場を守るために",
      "list": [
        "広場そのもの、設備、備品を大切に使用する。",
        "樹木や芝など、広場の緑を大切にする。",
        "広場内でテントの設置や宿泊はしない。",
        "許可のない物品の設置、放置はしない。",
        "許可のない興行、展示、集会、演説、競技会等は実施しない。",
        "許可のない物品の販売や営業、広告物の配布や貼り紙等はしない。",
        "許可のない業としての写真や映像の撮影はしない。",
        "他の利用者に迷惑となるような騒音や大声は出さない。"
      ]
    },
    {
      "title": "四．安全な広場を守るために",
      "list": [
        "許可のない火気の使用や喫煙はしない。",
        "危険物や悪臭のする物は持ち込まない。",
        "自転車は周囲に配慮した安全な速度で利用し、許可のない自動車の乗り入れはしない。",
        "他の利用者に危害が及んだりガラスが割れたりするような球技や遊びはしない。",
        "許可のない水辺への立ち入りはしない。"
      ]
    },
    {
      "title": "その他注意事項",
      "list": [
        "上記項目は、屋内広場と屋外広場、共通の内容です。",
        "専用利用の場合、必要な手続きや措置をした場合は上記項目にて規制された内容も行うことができる場合があります。",
        "防犯や広場管理のため、防犯カメラを設置していますので、ご了承ください。",
        "屋内広場は、水産物荷さばき施設として使用された頃のおもむきを残すため、天井の梁や床面を当時のまま使用しています。床面のコンクリートは目地がありますので、かかとの高い靴や小さなお子様、高齢の方等はご注意ください。"
      ]
    }
  ],
  "guide_pdf_url": "https://drive.google.com/file/d/1k1PH-gVnf7__yrdZHESSg9olpUek2DSI/view?usp=share_link",
  "drawing_pdf_url": "https://drive.google.com/file/d/1_TaSsPEW3WaUExwMbDx1FAFpuFV3APjd/view?usp=share_link",
  "drawing_inside_pdf_url": "https://drive.google.com/file/d/1cCigWXvoLsrRKl8kKYeJUjBktZYrPnFt/view?usp=sharing",
  "equipment_guide_pdf_url": "/data/equipment_catalog.pdf"
}
